import { Fragment } from 'react';

import { connect } from 'react-redux';

import rightArrow from '../../assets/img/rightArrow.svg';
import { scrollClickHandler } from '../../utils/utils';
import './ProviderLocationTable.css';

const ProviderLocationTable = (props) => {
  const { optData } = props;

  const locations = [];

  if (optData && optData.options) {
    optData.options.forEach(function (opt) {
      locations.push({
        name: opt.name,
        id: opt.ID,
        optionId: opt.optionId,
      });
    });
  }

  const hoverHandler = (data) => {
    props.setHoveredElement(data);
  };

  return (
    <Fragment>
      <div className="table-container" style={{ height: '60vh' }}>
        <table className="table table-bordered">
          <thead style={{ width: '100%' }}>
            <tr>
              {/* <th scope="col" style={{width:"60vh" ,textAlign:"left"}}>Location</th>*/}
              <th scope="col" style={{ textAlign: 'left' }}>
                Location
              </th>
              {/* <th scope="col" style={{width:"20%" ,textAlign:"right", paddingRight:"10px"}}>Distance</th> */}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {locations &&
              locations.map((p, index) => (
                <tr key={index} className="optionRow" onMouseEnter={() => hoverHandler(p)}>
                  <td className="bordered" style={{ width: '60vh', textAlign: 'left' }}>
                    <div>
                      <span className="marker__icon">{p.id}</span>
                      {p.name}
                    </div>{' '}
                  </td>
                  {/* <td  style={{width:"20%" ,textAlign:"right", borderLeft: "2px solid #ccc"}}>x</td> */}
                  <td
                    onClick={() => scrollClickHandler(p.optionId)}
                    style={{ borderLeft: '2px solid #ccc' }}
                  >
                    <img src={rightArrow} alt="" style={{ color: '#009F6F' }}></img>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    optData: state.optRed.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHoveredElement: (hoveredElement) =>
      dispatch({ type: 'SET_HOVERED_ELEMENT', hoveredElement }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProviderLocationTable);
